module.exports = __webpack_public_path__ + "img/gth-logo.49797718.png";